export default __webpack_public_path__ + "static/media/gallagher.89114749.png";